import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import CustomDatepicker from "../CustomDatepicker";
import InputText from "../InputText";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import CustomButton from "../CustomButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchQueryParams } from "../../utils/comman";
import { vinValidation } from "../../utils/helperFunction";

import get from "lodash/get";
import { useSelector } from "react-redux";

const _ = { get };

export default function vehicleOnBoarding(props) {
  let { elements } = props;

  const initialState = {
    purchaceDate:
      props.motorCycleDetails && props.motorCycleDetails.dateOfMfg
        ? new Date(props.motorCycleDetails.dateOfMfg)
        : "",
    motorCycle: "",
    varient: [],
    varientId: "",
    varientColor: "",
    regNumber: props.motorCycleDetails
      ? props.motorCycleDetails.registrationNo
      : "",
    vin: props.motorCycleDetails ? props.motorCycleDetails.vin : "",
    userID: "",
    userGUID: "",
    userId: "",
    otherMotorcycle: [],
    addVarient: "",
  };

  const [state, setState] = useState(initialState);

  // useEffect(() => {
  //   console.log("VEhicle onboard", props);
  //   const params = fetchQueryParams(props.query);
  //   state.userID = params.id;
  //   state.userGUID = params.guid;
  //   setState({ ...state });
  //   props.handleFetchMotorCycle("uk");
  // }, []);

  useEffect(() => {
    console.log("VEhicle onboard", props);
    let queryParams = props.query;
    if (queryParams === "") {
      state.userID = props.vehicleId;
      state.userId = props.vehicleId;
      state.userGUID = props.guid;
      setState({ ...state });
    } else {
      const params = fetchQueryParams(props.query);
      state.userID = params.id;
      state.userId = params.vehicleId;
      state.userGUID = params.guid;
      setState({ ...state });
    }
  }, [props.selectedId, props.guid]);

  useEffect(() => {
    props.handleFetchMotorCycle("uk");

    let newState = { ...state };
    newState.purchaceDate = "";
    newState.motorCycle = "";
    newState.vin = "";
    newState.varientColor = "";
    newState.varientId = "";
    newState.regNumber = "";
    setState(newState);
  }, []);

  console.log("statte", state);

  useEffect(() => {
    if (props.motorCycleDetails) {
      state.purchaceDate =
        props.motorCycleDetails.dateOfMfg &&
        new Date(props.motorCycleDetails.dateOfMfg);
      state.motorCycle = props.motorCycleDetails.vehicleModelName;
      state.vin = props.motorCycleDetails.vin;
      state.varientColor = props.motorCycleDetails.vehicleModelColor;
      state.varientId = props.motorCycleDetails.vehicleModelCode;
      state.regNumber = props.motorCycleDetails.registrationNo;
      setState({ ...state });
    }
  }, [props.motorCycleDetails]);

  const handlePurchaceDateChange = (date) => {
    state.purchaceDate = date;
    setState({ ...state });
  };

  const handleNameChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleVarientChange = (e) => {
    state.addVarient = e.target.value;
    setState({ ...state });
  };

  const handleChangeMotorCycle = (e) => {
    if (e.target.value !== "Select Motorcycle") {
      let value = JSON.parse(e.target.value);
      state.motorCycle = value.motorcycleName;
      var arrayName = Object.assign([], value.models);
      arrayName.push({ variantName: "Other" });
      state.varient = arrayName;
      state.varientId = "";
      state.varientColor = "";
      setState({ ...state });
    } else {
      state.motorCycle = "";
      state.varientId = "";
      state.varientColor = "";
      state.varient = [];
      setState({ ...state });
    }
  };

  const handleChangeVarient = (e) => {
    if (e.target.value !== "Select Variant") {
      let value = JSON.parse(e.target.value);
      console.log("varientId", value);
      state.varientId =
        value.variantName !== "Other" ? value.motorcycleModelId : "";
      state.varientColor = value.variantName;
      setState({ ...state });
    } else {
      state.varientId = "";
      state.varientColor = "";
      setState({ ...state });
    }
  };

  useEffect(() => {
    var arrayName = Object.assign([], props.motorCycle);
    arrayName.push({ motorcycleName: "Other" });
    state.otherMotorcycle = arrayName;
    setState({ ...state });
  }, [props.motorCycle]);

  const handleSelectVehicle = (vehicle) => {
    const params = fetchQueryParams(props.query);
    let data = {
      userGUID: state.userGUID,
      userID: state.userId,
      vehicleId: vehicle._id,
    };
    console.log("userId", state.userId);
    props.handlePendingVehicleOnboarding(data);
  };

  const handleFinalSubmitForVin = (e) => {
    e.preventDefault();
    if (props.editId === "update") {
      handleSubmitVin();
    } else {
      handleSumbit();
    }
  };

  const handleSubmitVin = (e) => {
    let data = {
      vin: state.vin,
      guid: state.userGUID,
      vehicleId: props.motorCycleDetails._id,
      userID: state.userID,
      dateOfMfg: moment(state.purchaceDate).format("YYYY-MM-DD"),
      regNumber: state.regNumber,
    };

    if (!props.motorCycleDetails)
      return toast.error(
        _.get(
          elements,
          "memberShipDetailElements.motorCycleValidationElement",
          "Motorcycle not found"
        )
      );
    if (state.regNumber === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regNumberValidationElement",
          "Enter Registration number"
        )
      );
    if (!vinValidation.test(state.regNumber))
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regValidationElement",
          "Registration number should be alphanumeric"
        )
      );
    // if (state.vin === "")
    //   return toast.error(
    //     _.get(
    //       elements,
    //       "memberShipDetailElements.vinEmptyValidationElement",
    //       "VIN cannot be empty"
    //     )
    //   );
    if (state.vin !== "") {
      if (!vinValidation.test(state.vin))
        return toast.error(
          _.get(
            elements,
            "memberShipDetailElements.vinValidationElement",
            "VIN should be alphanumeric"
          )
        );
      if (state.vin.length < 17)
        return toast.error(
          _.get(
            elements,
            "memberShipDetailElements.vinCharValidationElement",
            `Please enter a valid VIN code.
          It should have 17 digits and should not contain symbols`
          )
        );
    }
    if (state.purchaceDate === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.purchaseDateValidationElement",
          "Select Purchase date"
        )
      );

    return props.handleUpdateVin(data);
  };

  const handleSumbit = (e) => {
    let data = {
      dateOfMfg: moment(state.purchaceDate).format("YYYY-MM-DD"),
      vehicleModelName: state.motorCycle,
      vehicleModelCode: state.varientId,
      vehicleModelColor:
        state.varientColor && state.varientColor !== "Other"
          ? state.varientColor
          : state.addVarient,
      regNumber: state.regNumber ? state.regNumber.trim() : "",
      vin: state.vin ? state.vin.trim() : "",
      userID: state.userID,
      userGUID: state.userGUID,
    };

    if (state.motorCycle === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.selectMotorCycleValidationElement",
          "Select motorcycle"
        )
      );
    if (state.regNumber === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regNumberValidationElement",
          "Enter Registration number"
        )
      );
    if (!vinValidation.test(state.regNumber))
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.regValidationElement",
          "Registration number should be alphanumeric"
        )
      );
    // if (state.vin === "")
    //   return toast.error(
    //     _.get(
    //       elements,
    //       "vehicleOnBoardingElements.vinValidationElement",
    //       "Enter VIN"
    //     )
    //   );
    if (state.vin !== "") {
      if (!vinValidation.test(state.vin))
        return toast.error(
          _.get(
            elements,
            "memberShipDetailElements.vinValidationElement",
            "VIN should be alphanumeric"
          )
        );
      if (state.vin.length < 17)
        return toast.error(
          _.get(
            elements,
            "vehicleOnBoardingElements.vinCharValidationElement",
            `Please enter a valid VIN code.
            It should have 17 digits and should not contain symbols`
          )
        );
    }
    if (state.purchaceDate === "")
      return toast.error(
        _.get(
          elements,
          "vehicleOnBoardingElements.purchaseDateValidationElement",
          "Select Purchase date"
        )
      );

    return props.handleVehicleOnBoarding(data);
  };

  console.log("aaa", props.motorCycleDetails);
  return (
    <div className="hideSearch">
      {props.vechicleOnboardingStatus !== false ? <Loader /> : null}
      <Form onSubmit={handleFinalSubmitForVin}>
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "vehicleOnBoardingElements.headingElement",
                "Vehicle Application"
              )}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <h3 className="title-bar secondary-title f-weight-bold mb-3 pb-2 themeColor">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.subHeadingElement",
                    "Vehicle"
                  )}
                </h3>
              </Col>
              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.motorCycleLabel",
                    "Motorcycle*"
                  )}
                </Label>
                <FormGroup className="mt-1 pt-1">
                  <Input
                    type="select"
                    name="City"
                    className="w-100 customeSelectBtn"
                    onChange={handleChangeMotorCycle}
                    disabled={props.editId === "update"}
                  >
                    <option disabled="true" selected="true">
                      {props.motorCycleDetails
                        ? props.motorCycleDetails.vehicleModelName
                        : _.get(
                            elements,
                            "vehicleOnBoardingElements.selectMotorCycleElement",
                            "Select Motorcycle"
                          )}
                    </option>
                    {state.otherMotorcycle.map((item, index) => (
                      <option key={index} value={JSON.stringify(item)}>
                        {item.motorcycleName}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              {state.motorCycle !== "Other" ? (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <Label className="inputLabel">
                    {_.get(
                      elements,
                      "vehicleOnBoardingElements.variantLabel",
                      "Variant*"
                    )}
                  </Label>
                  <FormGroup className="mt-1 pt-1">
                    <Input
                      type="select"
                      name="City"
                      className="w-100 customeSelectBtn"
                      onChange={handleChangeVarient}
                      disabled={props.editId === "update"}
                    >
                      <option disabled="true" selected="true">
                        {props.motorCycleDetails
                          ? props.motorCycleDetails.vehicleModelColor
                          : _.get(
                              elements,
                              "vehicleOnBoardingElements.selectVariantElement",
                              "Select Variant"
                            )}
                      </option>
                      {state.varient &&
                        state.varient.map((item, index) => (
                          <option key={index} value={JSON.stringify(item)}>
                            {item.variantName}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
              ) : (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <InputText
                    labelName={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantLabel",
                      "Add New Variant"
                    )}
                    inputType={"text"}
                    inputName={"variantName"}
                    InputClass={"my-2 inputText"}
                    customValue={
                      props.motorCycleDetails &&
                      props.motorCycleDetails.vehicleModelColor
                    }
                    disabled={props.editId === "update"}
                    inputPlaceholder={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantPlaceholder",
                      "Add Variant"
                    )}
                    customOnChange={(e) => handleVarientChange(e)}
                  />
                </Col>
              )}
              {state.varientColor === "Other" ? (
                <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                  <InputText
                    labelName={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantLabel",
                      "Add New Variant"
                    )}
                    inputType={"text"}
                    inputName={"variantName"}
                    InputClass={"my-2 inputText"}
                    disabled={props.editId === "update"}
                    inputPlaceholder={_.get(
                      elements,
                      "vehicleOnBoardingElements.addNewVariantPlaceholder",
                      "Add Variant"
                    )}
                    customOnChange={(e) => handleVarientChange(e)}
                  />
                </Col>
              ) : null}

              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "vehicleOnBoardingElements.registrationNumberLabel",
                    "Registration Number*"
                  )}
                  inputType={"text"}
                  inputName={"regNumber"}
                  InputClass={"my-2 inputText"}
                  inputPlaceholder={_.get(
                    elements,
                    "vehicleOnBoardingElements.registrationNumberPlaceholder",
                    "Enter Registration Number"
                  )}
                  // customValue={
                  //   props.motorCycleDetails &&
                  //   props.motorCycleDetails.registrationNo
                  // }
                  customValue={state.regNumber}
                  customMaxLength={15}
                  customOnChange={(e) => handleNameChange(e)}
                />
              </Col>
              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <InputText
                  labelName={_.get(
                    elements,
                    "vehicleOnBoardingElements.vinLabel",
                    "VIN*"
                  )}
                  inputType={"text"}
                  inputName={"vin"}
                  InputClass={"my-2 inputText"}
                  // customValue={
                  //   props.motorCycleDetails && props.motorCycleDetails.vin
                  // }
                  customValue={state.vin}
                  customMaxLength={17}
                  inputPlaceholder={_.get(
                    elements,
                    "vehicleOnBoardingElements.vinPlaceholder",
                    "Enter VIN"
                  )}
                  customOnChange={(e) => handleNameChange(e)}
                />
              </Col>

              <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                <Label className="inputLabel">
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.dateOfPurchaseLabel",
                    "Date Of Purchase*"
                  )}
                </Label>
                <FormGroup className={`mt-1 pt-1`}>
                  <CustomDatepicker
                    // value={
                    //   props.motorCycleDetails &&
                    //   props.motorCycleDetails.dateOfMfg &&
                    //   new Date(props.motorCycleDetails.dateOfMfg)
                    // }
                    value={state.purchaceDate}
                    customPlaceHolder={_.get(
                      elements,
                      "vehicleOnBoardingElements.dateOfPurchasePlaceholder",
                      "Purchase Date"
                    )}
                    handleDateChange={handlePurchaceDateChange}
                    customShowMonthDropdown={true}
                    customShowYearDropdown={true}
                    customMaxDate={moment().toDate()}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "vehicleOnBoardingElements.submitButtonElement",
                  "Submit"
                )}
                customClass={"btn-outline-dark bg-none ml-2 mt-4 btnthemeColor"}
              />
            </div>
          </CardBody>
        </Card>
        <Row>
          <Col md="12">
            <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
              <span>
                {_.get(
                  elements,
                  "vehicleOnBoardingElements.vehicleInformationHeadingElement",
                  "VEHICLE INFORMATION"
                )}
              </span>
            </h2>
          </Col>

          {props.userVehicles.length !== 0 ? (
            props.userVehicles.map((userVehicle, index) => (
              <Col key={index} xs={12} md={12} sm={12} xl={6} className="mb-3">
                <Card className="byk-card">
                  <CardBody className="p-2">
                    <div className="d-flex flex-column">
                      <div className="w-100  ml-auto information px-2 py-2 position-relative">
                        <div className="d-flex flex-column">
                          <span className="text-capitalize d-flex flex-row pr-2">
                            <span className="mr-2 title">
                              {_.get(
                                elements,
                                "vehicleOnBoardingElements.motorcycleNameElement",
                                "Motorcycle Name -"
                              )}
                            </span>
                            <span className="detail">
                              {userVehicle.vehicleModelName}
                            </span>
                          </span>

                          <span className="text-capitalize d-flex flex-row pr-2">
                            <span className="mr-2 title">
                              {_.get(
                                elements,
                                "vehicleOnBoardingElements.motorcycleColorElement",
                                "Motorcycle Color -"
                              )}
                            </span>
                            <span className="detail">
                              {userVehicle.vehicleModelColor}
                            </span>
                          </span>

                          <span className="text-capitalize d-flex flex-row pr-2">
                            <span className="mr-2 title">
                              {_.get(
                                elements,
                                "vehicleOnBoardingElements.vINElement",
                                "VIN -"
                              )}
                            </span>
                            <span className="detail">{userVehicle.vin}</span>
                          </span>

                          <span className="text-capitalize d-flex flex-row pr-2">
                            <span className="mr-2 title">
                              {" "}
                              {_.get(
                                elements,
                                "vehicleOnBoardingElements.registrationNumberElement",
                                "Registration Number - "
                              )}
                            </span>
                            <span className="detail">
                              {userVehicle.registrationNo}
                            </span>
                          </span>
                          <span className="text-capitalize d-flex flex-row pr-2">
                            <span className="mr-2 title">
                              {" "}
                              {_.get(
                                elements,
                                "vehicleOnBoardingElements.purchaseDateElement",
                                "Purchase Date - "
                              )}
                            </span>
                            <span className="detail">
                              {userVehicle.dateOfMfg &&
                                moment(userVehicle.dateOfMfg).format(
                                  "DD-MM-YYYY"
                                )}
                            </span>
                          </span>
                        </div>
                      </div>
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "memberShipDetailElements.selectMotorcycleButtonElement",
                          "Select Motorcycle"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={() => handleSelectVehicle(userVehicle)}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center">
                <strong>
                  {_.get(
                    elements,
                    "vehicleOnBoardingElements.noVehiclesToShowElement",
                    "No Vehicles To Show"
                  )}
                </strong>
              </p>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
}
